import RequirePhysicianOrAncillaryMiddleware from 'middlewares/RequirePhysicianOrAncillaryMiddleware'
import RequireUserMiddleware from 'middlewares/RequireUserMiddleware'

export default [
    {
        path: '/availability/:action',
        name: 'availability',
        view: 'availability/Availability',
        default: {},
        middlewares: [RequirePhysicianOrAncillaryMiddleware, RequireUserMiddleware],
    },
]
